<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="resetData">
      <!-- Search Component -->
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select v-model="searchParams.hotelId">
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Trạng thái</div>

                <el-select
                  v-model="searchParams.isActive"
                  placeholder="Vui lòng chọn"
                  @change="attachData"
                >
                  <el-option label="Tất cả" value=""> </el-option>
                  <el-option label="Đang hoạt động" :value="true"> </el-option>
                  <el-option label="Không hoạt động" :value="false">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Số phòng</div>
                <div class="child-w-80">
                  <!-- v-model="searchParams.roomNumber" -->
                  <el-autocomplete
                    v-model="searchParams.roomNumber"
                    width="100%"
                    class="inline-input"
                    :fetch-suggestions="querySearch"
                    :trigger-on-focus="false"
                    :value-key="'room_num'"
                    @select="handleSelect"
                  >
                  </el-autocomplete>
                  <!-- @change="changeNumberRoom" -->
                  <!-- value-key="room_num" -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div style="display: flex; gap: 10px; align-items: center;">
        <select placeholder="Hạng phòng">
          <option value="1">Volvo</option>
          <option value="2">BMW</option>
          <option value="3">Porsche</option>
        </select>
      </div>
      <div style="display: flex; gap: 10px; align-items: center;">
        <input type="text" placeholder="Số phòng">
      </div> -->
      </div>
    </search-comp>
    <!-- <RoomSearch :room-level="roomLevelList" @onSearch="onSearch" /> -->

    <div v-loading="loading" class="grid-scroll mt-10">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :rows="rows"
        class="agGrid"
        :row-multi-select-with-click="true"
        @refresh="onRefresh"
        @selectionChanged="selectionChanged"
      />
    </div>
    <div class="grid-bottom">
      <GridPaging
        target="agGrid"
        :total-size="totalPage"
        :page-num="currentPage"
        @pageChanged="onPageChanged"
        @onPageSizeChange="onPageSizeChange"
      />
    </div>
    <div class="button-containers">
      <button
        :disabled="isDisableDelete"
        class="btn primary small outline"
        @click="deleteRoom"
      >
        {{ $t('button.delete') }}
      </button>
      <button
        :disabled="isDisableModify || disabledByLongTask"
        class="btn primary small"
        @click="updateRoomView"
      >
        <span v-if="disabledByLongTask" class="load"></span>
        {{ $t('button.modify') }}
      </button>
      <button class="btn primary small" @click="addView">
        {{ $t('button.add') }}
      </button>
      <!-- <FileInput
        ref="uploadFile"
        :title="$t('button.uploadFromExcel')"
        @onSelectFile="onSelectUploadList"
      /> -->

      <!-- <button class="btn primary small">
        {{ $t('button.uploadFromExcel') }}
      </button> -->
    </div>
    <el-dialog
      :title="!isEdit ? 'Thêm phòng' : 'Sửa phòng'"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <div class="das-form-container">
        <validation-observer ref="formValidator">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Hạng phòng</div>
                  <validation-provider rules="required" name="Hạng phòng">
                    <div class="child-w-80">
                      <!-- <select
                        v-model="form.room_level_id"
                        placeholder="Chọn hạng phòng"
                        :disabled="isEdit"
                      >
                        <option
                          v-for="option in roomLevelList"
                          :key="option.id"
                          :label="option.code"
                          :value="option.id"
                        />
                      </select> -->
                      <select-with-search-table
                        style="width: 100%"
                        :rows="roomLevelList"
                        :columns="columnsRoomLevel"
                        :value="form.room_level_id"
                        :selected-index-field-value="form.room_level_id"
                        index-field="id"
                        :dropdown-width="400"
                        @selectionChanged="onSelectRowRoomLevel"
                      >
                        <template
                          v-slot:value="{ selectedValue: selectedData }"
                        >
                          {{ selectedData?.code }}
                        </template>
                      </select-with-search-table>
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Giá thiết kế</div>
                  <validation-provider rules="" name="Giá thiết kế">
                    <div class="child-w-80">
                      <VxCurrencyInput
                        v-model="form.price"
                        :options="optionsCurrency"
                      />
                    </div>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Số phòng</div>
                  <validation-provider rules="required|max:50" name="Số phòng">
                    <div class="child-w-80">
                      <input v-model="form.room_num" type="text" />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Thuộc tính</div>
                  <validation-provider rules="" name="Thuộc tính phòng">
                    <el-select
                      v-model="form.property_id_list"
                      multiple
                      style="width: 100%"
                      :collapse-tags="true"
                    >
                      <el-option
                        v-for="option in roomProperties"
                        :key="option.id"
                        :label="option.code"
                        :value="option.id"
                      />
                    </el-select>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">Tầng</div>
                  <validation-provider rules="required|max:50" name="Tầng">
                    <div class="child-w-80">
                      <input v-model="form.floors" type="text" />
                    </div>
                  </validation-provider>
                </div>
              </div>
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label">Khóa từ</div>
                  <validation-provider rules="" name="Khóa từ">
                    <!-- <el-select v-model="form.lock_id" style="width: 100%">
                      <el-option
                        v-for="(option, index) in lockList"
                        :key="index"
                        :label="option.lock_id"
                        :value="option.lock_id"
                      />
                    </el-select> -->
                    <select-with-search-table
                      style="width: 100%"
                      index-field="lock_id"
                      :search-fields="['lock_id', 'alias']"
                      :selected-index-field-value="form.lock_id"
                      :value="form.lock_id"
                      :rows="lockRows"
                      :columns="lockCols"
                      :dropdown-width="400"
                      :is-remove-btn="true"
                      @selectionChanged="onSelectFreeLock"
                    >
                      <template v-slot:value="{ selectedValue: selectedData }">
                        <div>
                          <span>
                            {{
                              `${selectedData?.lock_id || ''} - ${
                                selectedData?.alias || ''
                              }`
                            }}
                          </span>
                        </div>
                      </template>
                    </select-with-search-table>
                  </validation-provider>
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label" style="margin-right: 10px">Hoạt động</div>
                  <el-switch
                    v-model="form.active"
                    active-color="#357456"
                    inactive-color="#CAC9C9"
                  />
                </div>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <div class="das-form-input">
                  <div class="label">Mô tả</div>
                  <validation-provider rules="max:255" name="Mô tả">
                    <textarea
                      v-model="form.desc"
                      style="width: 100%"
                      rows="4"
                    />
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
        </validation-observer>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button v-if="isEdit" class="btn primary small" @click="updateRoom">
            {{ $t('button.update') }}
          </button>

          <button v-else class="btn primary small" @click="addRoom">
            {{ $t('button.create') }}
          </button>
        </div>
        <!-- <el-button @click="dialogFormVisible = false">Huỷ</el-button>
        <el-button
          v-if="isEdit"
          type="primary"
          @click="updateRoom"
        >Cập nhật</el-button>
        <el-button v-else type="primary" @click="addRoom">Tạo mới</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Breadcrumb from '@/components/Breadcrumb'
import RightPanel from '@/components/RightPanel'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import bus from '@/utils/bus'
import FileInput from '@/components/ui/FileInput.vue'

import { component as VueNumber } from '@coders-tm/vue-number-format'
import { Message } from 'element-ui'
import {
  getListRoomApi,
  addRoomApi,
  updateRoomApi,
  deleteRoomApi,
  getAllRoomApi,
  getRoombyID,
  getListRoomNumApi
} from '@/api/Room/room'
import { getAllRoomPropertyApi } from '@/api/Room/roomProperty'
import { getAllRoomLevelApi } from '@/api/Room/roomLevel'
import { getAllBuildingApi } from '@/api/Room/building'
import { getAllHotel } from '@/api/hotel'
import {
  getLockListFree,
  updateLockForRoom,
  updateLockBeforeDeleteRoom
} from '@/api/configuration/lockmanagement/lock'
import { checkRunningTask } from '@/api/task'

export default {
  components: {
    Breadcrumb,
    RightPanel,
    SelectWithSearchTable,
    VueNumber,
    FileInput
  },
  data() {
    return {
      optionsCurrency: {
        currency: 'USD',
        precision: 0,
        currencyDisplay: 'hidden',
        hideGroupingSeparatorOnFocus: false,
        valueRange: {
          min: 0,
          max: 9999999999
          // max: 10
        },
        useGrouping: true
      },
      isDisableModify: false,
      isDisableDelete: false,
      links: [],
      loading: false,
      roomProperties: [],
      hotelList: [],
      roomLevelList: [],
      buildingList: [],
      lockList: [],
      roomConnectOptions: [],
      titlePopup: 'Thêm phòng',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      searchParams: {
        pageSize: 10,
        pageNum: 1,
        orderTp: 'ASC',
        roomLevelId: '',
        roomNumber: '',
        hotelId: '',
        isActive: true
      },
      form: {
        id: null,
        room_num: '',
        building_id: '',
        room_level_id: '',
        floors: '',
        price: 0,
        bed_num: 0,
        lock_id: null,
        alias_smart_lock: null,
        active: true,
        desc: '',
        property_id_list: [],
        connect_id_list: []
      },
      defaultForm: {
        id: null,
        room_num: '',
        building_id: '',
        room_level_id: '',
        floors: '',
        bed_num: 0,
        active: true,
        price: 0,
        lock_id: null,
        alias_smart_lock: null,
        desc: '',
        property_id_list: [],
        connect_id_list: []
      },
      columnsBuilding: [
        {
          headerName: 'Mã tòa nhà',
          field: 'building_no',
          // cellClass: "grid-cell-centered",
          width: 100
        },
        {
          headerName: 'Mô tả',
          field: 'name'
          // cellRenderer: 'CellRenderTextInput',
          // cellClass: "grid-cell-centered",
        }
      ],
      columnsRoomLevel: [
        {
          headerName: 'Mã hạng phòng',
          field: 'code',
          // cellClass: "grid-cell-centered",
          // minwidth: 100
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Tên',
          field: 'name',
          flex: 1
          // cellRenderer: 'CellRenderTextInput',
          // cellClass: "grid-cell-centered",
        }
      ],
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 50,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },
        {
          headerName: 'Số phòng',
          field: 'room_num',
          tooltipField: 'room_num',
          maxWidth: 180,
          sortable: false
        },
        {
          headerName: 'Hạng phòng',
          field: 'room_level_name',
          maxWidth: 180,
          sortable: false
        },

        // {
        //   headerName: 'Tên toà nhà',
        //   field: 'building_name',
        //   sortable: false
        // },

        {
          headerName: 'Thuộc tính phòng',
          field: 'property_names',
          sortable: false,
          tooltipField: 'property_names'
        },
        {
          headerName: 'Tầng',
          field: 'floors',
          sortable: false,
          maxWidth: 120
        },
        // {
        //   headerName: 'Số giường',
        //   field: 'bed_num',
        //   sortable: false
        // },

        {
          headerName: 'Giá thiết kế',
          field: 'price',
          valueGetter: params => {
            if (params.data.price !== null || params.data.price !== undefined) {
              return Number(params.data.price).toLocaleString('en')
            } else {
              return null
            }
          },
          sortable: false,
          maxWidth: 180,
          minWidth: 100
        }
        // {
        //   headerName: 'Mã khoá từ',
        //   field: 'key_code',
        //   maxWidth: 140,
        //   sortable: false
        // },
        // {
        //   headerName: 'Phòng thông nhau',
        //   field: 'connected_room_numbers',
        //   sortable: false
        // }
      ],
      rows: [],

      // datnt
      lockCols: [
        {
          headerName: 'Mã khóa từ',
          field: 'lock_id',
          minWidth: 120,
          maxWidth: 150
        },
        {
          headerName: 'Khóa',
          field: 'alias',
          // tooltipFiled: 'desc',
          flex: 1
        }
      ],
      lockRows: [],
      oldLockId: null,
      disabledByLongTask: false
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : this.resetItemInfo()
    }
  },
  created() {
    this.getAllRoomProperties()
    this.getListHotel()
    this.getRoomLevel()
    this.getListBuilding()
    this.getListRoomNum()
  },
  mounted() {
    this.getAllRoom()
    this.attachData()
    this.fnGetLockListFree()
  },
  methods: {
    // datnt card-service
    onSelectFreeLock(selected) {
      this.form.lock_id = selected?.lock_id
    },

    resetData() {
      this.searchParams.hotelId = ''
      this.searchParams.roomNumber = ''
      this.searchParams.isActive = true
      this.attachData()
    },
    async selectionChanged(rows) {
      if (rows.length == 0) {
        this.isDisableModify = true
        this.isDisableDelete = true
      } else if (rows.length > 1) {
        this.isDisableModify = true
        this.isDisableDelete = false
      } else {
        this.isDisableModify = false
        this.isDisableDelete = false
      }

      if (rows.length === 1) {
        this.disabledByLongTask = await checkRunningTask(rows[0]?.id, 'ROOM')
      } else {
        this.disabledByLongTask = false
      }
    },
    onSelectRoomLevelSearch(val) {
      val == null
        ? (this.searchParams.roomLevelId = null)
        : (this.searchParams.roomLevelId = val.id)
    },
    onSelectRowRoomLevel(val) {
      this.form.room_level_id = val.id
    },
    onSelectRowBuilding(val) {
      this.form.building_id = val.id
    },
    resetItemInfo() {
      this.form = { ...this.defaultForm }
    },
    onRefresh(data) {
      const params = {
        orderBy: data.orderBy,
        orderTp: data.sort
      }
      this.searchParams = { ...this.searchParams, ...params }
      this.attachData()
    },
    async onPageChanged(pageNum) {
      this.searchParams.pageNum = pageNum
      await this.attachData()
    },
    async onPageSizeChange(pageSize) {
      this.searchParams.pageSize = pageSize
      this.searchParams.pageNum = 1
      await this.attachData()
    },
    async onSearch(data) {
      this.searchParams.pageNum = 1
      Object.assign(this.searchParams, data)
      await this.attachData()
    },

    async attachData() {
      // bus.$emit("startLoader", { msg: "" });
      this.loading = true
      let data = await getListRoomApi(this.searchParams)
      // bus.$emit("endLoader");
      this.loading = false
      this.rows = data.data
      this.totalPage = Math.ceil(data.total / this.searchParams.pageSize)
      this.currentPage = data.data.length === 0 ? 0 : data.page_num
    },
    async getListRoomNum() {
      let data = await getListRoomNumApi()
      this.links = data.data
    },
    async getAllRoomProperties() {
      let data = await getAllRoomPropertyApi()
      this.roomProperties = data.data
    },
    async getRoomLevel() {
      let data = await getAllRoomLevelApi()
      this.roomLevelList = data.data
    },
    async getListHotel() {
      let data = await getAllHotel()
      this.hotelList = data.data
    },
    async getListBuilding() {
      let data = await getAllBuildingApi()
      this.buildingList = data.data
    },
    async getAllRoom() {
      let data = await getAllRoomApi()
      this.roomConnectOptions = data.data
    },
    async fnGetLockListFree() {
      let data = await getLockListFree()
      // this.lockList = data.data
      this.lockRows = data.data
    },
    querySearch(queryString, cb) {
      var links = this.links
      var results = queryString
        ? this.links.filter(item =>
            item.room_num.toLowerCase().includes(queryString.toLowerCase())
          )
        : links
      // call callback function to return suggestions
      cb(results)
    },
    // createFilter(queryString) {
    //   return link => {
    //     return (
    //       link.room_num.toLowerCase().indexOf(queryString.toLowerCase()) === 0
    //     )
    //   }
    // },
    handleSelect(item) {
      this.searchParams.hotelId = item.hotel_id
    },
    changeNumberRoom(value) {
      this.searchParams.roomNumber = value
    },
    async addRoom() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return
      let data = await addRoomApi(this.form)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.getListRoomNum()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {
          this.fnGetLockListFree()
        })
    },
    async updateRoom() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) == false)
        return

      // datnt - card service
      if (this.oldLockId != null && this.oldLockId !== this.form.lock_id) {
        const response = await updateLockForRoom({
          oldLockId: this.oldLockId,
          newLockId: this.form.lock_id,
          roomId: this.form.id
        })
        if (response?.is_error) {
          this.$message({
            type: 'error',
            message: 'Lỗi cập nhật khóa từ'
          })
        } else {
        }
      }

      let data = await updateRoomApi(this.form)
        .then(async res => {
          const message = res.message
          await this.attachData()
          this.getListRoomNum()
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
        .finally(() => {
          this.fnGetLockListFree()
        })
    },
    async deleteRoom() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      const id_list = rowsSelected.map(item => item.id)

      // datnt - card service
      const response = await updateLockBeforeDeleteRoom({
        idList: id_list
      })
      if (response?.is_error) {
        this.$message({
          type: 'error',
          message: 'Lỗi cập nhật khóa từ'
        })
      } else {
      }

      if (id_list.length == 0) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        this.$vxConfirm(this.$t('alert.deleteRoomConfirm'), () => {
          deleteRoomApi({
            id_list: id_list
          })
            .then(async res => {
              const message = res.message
              await this.attachData()
              this.getListRoomNum()
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: this.$t(`successMsg.${message}`)
              })
            })
            .catch(error => {
              const message = error.response?.data?.message || 'default'
              this.$message({
                type: 'error',
                message: this.$t(`errorMsg.${message}`)
              })
            })
            .finally(() => {
              this.fnGetLockListFree()
            })
        })
      }
    },
    addView() {
      this.dialogFormVisible = true
      this.isEdit = false
    },
    async updateRoomView() {
      const gridApi = this.$refs.agGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected.length == 0 || rowsSelected.length > 1) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectRow')
        })
      } else {
        const rowData = await getRoombyID(rowsSelected[0].id)
        Object.assign(this.form, rowData.data)
        // this.form = { ...rowData.data };
        this.titlePopup = 'Sửa phòng'
        this.isEdit = true
        this.dialogFormVisible = true

        await this.fnGetLockListFree()
        this.oldLockId = this.form.lock_id
        if (this.form.lock_id != null) {
          this.lockRows.unshift({
            lock_id: this.form.lock_id,
            alias: this.form.alias_smart_lock
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.inputsearch {
  display: flex;
  margin-bottom: 20px;
}
</style>
